/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import { observer } from 'mobx-react'
import React from 'react'
import { TransactionStatus } from '../../../configuration/Enums/TransactionStaus'
import { IDemographic, IDemographicIndividualResponse, IIndividual } from '../../../services/CoverageDiscoveryResponseStateManager/contracts'
import './CoverageDiscoveryPendingComponent.scss'
import { EligibilityRequestDetailsComponent } from '../DisplayTemplates/EligibilityRequestDetails/EligibilityRequestDetails'
import { Link } from 'react-router-dom'
import { CommonUtils } from '../../../utils/CommonUtils'

interface ICoverageDiscoveryPendingProps {
	cdTransactionStatus?: number
	transactionRequestDetails?: IIndividual
	transactionRequestGuarantorDetails?: IIndividual
	transactionId?: number
	demographic: IDemographic
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ICoverageDiscoveryPendingState {}

@observer
export class CoverageDiscoveryPendingComponent extends React.Component<ICoverageDiscoveryPendingProps, ICoverageDiscoveryPendingState> {
	renderTransactionMessages(cdTransactionStatus?: number) {
		let message = ''
		switch (cdTransactionStatus) {
			case TransactionStatus.Complete:
				message = 'Insurance Discovery was performed on this individual but no coverage could be located. If possible, please try your search again with additional patient information.'
				break
			case TransactionStatus.Pending:
				message = 'Transaction is in pending'
				break
			case TransactionStatus.Error:
				message = 'Error occurred while processing transaction'
				break
			case TransactionStatus.TimedOut:
				message = 'Transaction process is timed out'
				break
			case TransactionStatus.Processing:
				message = 'Error occurred while processing transaction'
				break
			default:
				message = `Unknown transaction status ${cdTransactionStatus}`
				break
		}
		return message
	}

	render(): React.ReactNode {
		let showDVLabel
		let demographicConfidenceScore
		const demographicResponse = this.props.demographic
		const demographicIndividual = {} as IDemographicIndividualResponse
		const demographicGuarantor = {} as IDemographicIndividualResponse
		if (demographicResponse) {
			if (demographicResponse.guarantor && demographicResponse.guarantorId) {
				demographicGuarantor.individual = demographicResponse.guarantor
				demographicGuarantor.id = demographicResponse.guarantorId
				demographicGuarantor.Deceased = demographicResponse.guarantorDeceased
			} else {
				demographicIndividual.individual = demographicResponse.individual
				demographicIndividual.id = demographicResponse.individualId
				demographicIndividual.Deceased = demographicResponse.individualDeceased
			}
		}

		if (this.props.transactionRequestGuarantorDetails && demographicGuarantor.id) {
			showDVLabel = this.setDVLabel(this.props.transactionRequestGuarantorDetails, demographicGuarantor.individual)
			demographicConfidenceScore = demographicGuarantor.confidenceScore && demographicGuarantor.confidenceScore.trim()
		} else {
			showDVLabel = this.setDVLabel(this.props.transactionRequestDetails, demographicIndividual.individual)
			demographicConfidenceScore = demographicIndividual.confidenceScore && demographicIndividual.confidenceScore.trim()
		}

		return (
			<div className="response-content row  tab-content">
				<div className="width100P">
					{this.props.cdTransactionStatus !== TransactionStatus.Processing && (
						<div className="text-right">
							<Link to={`/CoverageDiscoveryRequest/${this.props.transactionId}`}>RERUN</Link>
						</div>
					)}
					<div className="contentBody  cd-response" style={{ display: 'inline-block', width: '98%' }}>
						<div className="span12" style={{ marginTop: '1.2em' }}>
							<div className="row-fluid">
								<div className="span12">
									<h4>{this.renderTransactionMessages(this.props.cdTransactionStatus)}</h4>
								</div>
								<div className="span12" style={{ float: 'left', marginBottom: '0px' }}>
									<div style={{ float: 'left', width: '49%', position: 'relative' }} className="col1ForIE8 requestIndividual">
										<EligibilityRequestDetailsComponent transactionRequestDetails={this.props.transactionRequestDetails} demographicResponse={demographicIndividual} title={'Request'} />
									</div>
								</div>
								<div className="span12" style={{ display: this.props.transactionRequestGuarantorDetails ? '' : 'none', marginBottom: '0px' }}>
									<div style={{ float: 'left', width: '49%', position: 'relative' }} className="col1ForIE8 requestGuarantor">
										<EligibilityRequestDetailsComponent transactionRequestDetails={this.props.transactionRequestGuarantorDetails} demographicResponse={demographicGuarantor} title={'Request - Guarantor'} />
									</div>
								</div>
								<div className="span12 dvInfoLabel" style={{ visibility: showDVLabel ? 'visible' : 'hidden', marginTop: '0px', border: '1px solid #d1ccbf', width: '49%' }}>
									<div style={{ color: 'green', padding: '10px' }}>
										<span>
											<strong>Information identified via demographic verification.</strong>
										</span>
										<br />
										<strong>Demographic Confidence Score: {demographicConfidenceScore == '' || demographicConfidenceScore == null ? '' : demographicConfidenceScore == 'Y' ? 'High' : 'Low'}</strong>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	setDVLabel(model, demographicModel): boolean {
		let showDVLabel = false
		if (model && demographicModel) {
			showDVLabel = CommonUtils.isDVDataDifferent(model.firstName, demographicModel.firstName) || CommonUtils.isDVDataDifferent(model.middleName, demographicModel.middleName) || CommonUtils.isDVDataDifferent(model.lastName, demographicModel.lastName) || CommonUtils.isDVDataDifferent(model.gender, demographicModel.gender) || CommonUtils.isDVDataDifferent(model.dateOfBirth, demographicModel.dateOfBirth) || CommonUtils.isDVDataDifferent(model.socialSecurityNumber, demographicModel.socialSecurityNumber) || CommonUtils.isDVAddressDifferent(model.address1, model.address2, demographicModel.address1) || CommonUtils.isDVDataDifferent(model.city, demographicModel.city) || CommonUtils.isDVDataDifferent(model.stateCodeId, demographicModel.stateCodeId) || CommonUtils.isZipCodeDifferent(model.zip, demographicModel.zip) || CommonUtils.isDVDataDifferent(model.phoneNumber, demographicModel.phoneNumber)
		}
		return showDVLabel
	}
}
